import React from 'react';
import { connect } from 'react-redux';
import NProgress from 'nprogress';
import { CSSTransitionGroup } from 'react-transition-group';

import PdfService from '../../../services/PdfService';
import * as applyOffersActions from '../../../redux/applyOffers';
import dismissedIcon from '../../../svg/dismissed.svg';
import likedIcon from '../../../svg/liked.svg';
import selectedIcon from '../../../svg/selected.svg';
import unreviewedIcon from '../../../svg/unreviewed.svg';
import exportPdf from '../../../svg/export-pdf.svg';
import successCheck from '../../../svg/success.svg';
import { APP_URL } from '../../../services/constants';
import './apply-menu.scss';
import moment from 'moment';
import NeonTo from '../../../services/NeonTo';

interface State {
  PDFUrl?: string;
  isRenderingPDF: boolean;
  renderingStartedAt?: number;
}

interface Props {
  allowDownload?: boolean;
  applyOffers: any;
  buttonAction: Function;
}

class ApplyMenu extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      renderingStartedAt: undefined,
      isRenderingPDF: false,
    };
  }

  onChangeType(type: string) {
    this.props.buttonAction(type);

    this.setState({
      PDFUrl: undefined,
      renderingStartedAt: undefined,
      isRenderingPDF: false,
    });
  }

  buildButton(type: string, number: string) {
    let icon;

    switch (type) {
      case 'dismissed':
        icon = dismissedIcon;
        break;
      case 'liked':
        icon = likedIcon;
        break;
      case 'unreviewed':
        icon = unreviewedIcon;
        break;
      case 'selected':
      default:
        icon = selectedIcon;
        break;
    }

    return (
      <button
        className={this.props.applyOffers.selectedFilter === type ? `${type} active` : type}
        onClick={() => this.onChangeType(type)}
      >
        {/**
         * <div className={type === 'unreviewed' ? 'left smaller' : 'left'}>
          <img src={icon}></img>
        </div>
         */}
        <div className="right">
          <p className="number">{number}</p>
          <p className="text">{type.toUpperCase()}</p>
        </div>
      </button>
    );
  }

  hideRenderingPDFMessage() {
    let timeout =
      this.state.renderingStartedAt && Date.now() - this.state.renderingStartedAt < 1000 ? 2000 : 0;

    setTimeout(() => {
      this.setState({
        renderingStartedAt: undefined,
        isRenderingPDF: false,
      });
    }, timeout);
  }

  async downloadPdf() {
    NProgress.start();

    this.setState({
      renderingStartedAt: Date.now(),
      isRenderingPDF: true,
      PDFUrl: undefined,
    });

    try {
      const businessInfoRaw = localStorage.getItem('businessInfo');
      const username = businessInfoRaw
        ? JSON.parse(businessInfoRaw).username
        : this.props.applyOffers.offer.title;

      const filename = `${username}+${this.props.applyOffers.selectedFilter}+${moment().format(
        'MMDDYY'
      )}.pdf`;
      const result: any = await PdfService.generate(
        `${APP_URL}/offer/apply/export/${this.props.applyOffers.offer.id}/${this.props.applyOffers.selectedFilter}`,
        {
          orientation: 'portrait',
          filename: filename,
        }
      );

      if (result.url) {
        this.setState({
          PDFUrl: await NeonTo.url(result.page_url ?? result.url),
        });

        const a = document.createElement('A') as HTMLAnchorElement;
        a.href = result.url;
        a.download = filename;
        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
      }

      NProgress.done();

      this.hideRenderingPDFMessage();
    } catch (error) {
      NProgress.done();

      this.hideRenderingPDFMessage();
    }
  }

  render() {
    const buckets = this.props.applyOffers.buckets;
    const dismissed = buckets.find((bucket) => bucket.name === 'dismissed');
    const unreviewed = buckets.find((bucket) => bucket.name === 'unreviewed');
    const liked = buckets.find((bucket) => bucket.name === 'liked');
    const selected = buckets.find((bucket) => bucket.name === 'selected');

    return (
      <nav className="apply-menu">
        {this.state.isRenderingPDF ? (
          <CSSTransitionGroup
            transitionName="apply-menu"
            transitionAppear={true}
            transitionAppearTimeout={1000}
            transitionLeaveTimeout={1000}
            transitionEnter={false}
            transitionLeave={true}
          >
            <div className="apply-menu-loading">
              <span className="apply-menu-loading_text">
                This may take a few moments. We appreciate your patience as we generate your PDF of
                applicants.
              </span>
            </div>
          </CSSTransitionGroup>
        ) : null}

        {this.state.PDFUrl ? (
          <div className="apply-menu-loading apply-menu-loading--successful">
            <span className="apply-menu-loading_sentence apply-menu-loading_sentence--stressed-title">
              <img src={successCheck}></img>
              PDF created!
            </span>
            <span className="apply-menu-loading_sentence">
              Copy your download link to share it with others.
            </span>
            <span className="apply-menu-loading_sentence apply-menu-loading_sentence--bold">
              Link expires in 7 days.
            </span>
            <input
              className="apply-menu-loading_input"
              readOnly
              value={this.state.PDFUrl}
              onFocus={(event) => {
                event.target.select();
              }}
            />
            <button
              className="apply-menu-loading_button"
              onClick={() => {
                navigator.clipboard.writeText(this.state.PDFUrl ?? '');
              }}
            >
              Copy link
            </button>
          </div>
        ) : null}

        {this.buildButton('dismissed', dismissed.count_of_models)}
        {this.buildButton('unreviewed', unreviewed.count_of_models)}
        {this.buildButton('liked', liked.count_of_models)}
        {this.buildButton(
          'selected',
          `${selected.count_of_models}/${this.props.applyOffers.offer.available_spots}`
        )}

        {buckets.find((bucket) => this.props.applyOffers.selectedFilter === bucket.name)
          .count_of_models > 0 && this.props.allowDownload !== false ? (
          <img onClick={() => this.downloadPdf()} className="print" src={exportPdf}></img>
        ) : null}
      </nav>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(ApplyMenu);
